<template>
    <div>
        <iframe   :src="$ifreamUrl + '/model' "  frameborder="0" style="width: 100%;height: 100vh"></iframe>
        <!-- <div  style="width:400px;height:300px;position: absolute;bottom: 0;z-index: 99;">
            <img style="width: 100%;height: 100%" src="../../../static/img/jicheng.png" alt="">
        </div> -->
        <div style="position: absolute;left: 410px;bottom: 10px;z-index: 99">
            <el-button type="info" @click="reload">重新开始</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "index",
        methods:{
            reload(){
                window.location.reload()
            },
        },

        mounted(){

        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/webGl/index.vue